/** Tiered per-screen campaign pricing (keep in sync with invertAPI advertiserScreenPricing.js).
 *  $199 all-screens bundle applies to Invert fleet only (ATM / YaxiTV excluded).
 */
export const SLIDES_PER_SCREEN_DAY = 180;
export const BILLING_DAYS_PER_PERIOD = 30;
export const PLAYS_PER_SCREEN_MONTH = SLIDES_PER_SCREEN_DAY * BILLING_DAYS_PER_PERIOD;
export const SINGLE_SCREEN_PRICE_USD = 59.99;
export const ALL_SCREENS_BUNDLE_USD = 199;

function normalizeFleetSize(fleetSize) {
    const n = Math.floor(Number(fleetSize) || 0);
    return Math.max(1, n);
}

export function calculateCampaignTotalUsd(screenCount, fleetSize) {
    const n = Math.max(0, Math.floor(Number(screenCount) || 0));
    if (n <= 0) return 0;
    const fleet = normalizeFleetSize(fleetSize);
    if (n === 1) return SINGLE_SCREEN_PRICE_USD;
    if (n >= fleet) return ALL_SCREENS_BUNDLE_USD;
    if (fleet === 1) return SINGLE_SCREEN_PRICE_USD;
    const span = fleet - 1;
    const progress = (n - 1) / span;
    const total = SINGLE_SCREEN_PRICE_USD + (ALL_SCREENS_BUNDLE_USD - SINGLE_SCREEN_PRICE_USD) * progress;
    return Math.round(total * 100) / 100;
}

export function calculateEffectivePerScreenUsd(screenCount, fleetSize) {
    const n = Math.floor(Number(screenCount) || 0);
    if (n <= 0) return 0;
    const total = calculateCampaignTotalUsd(n, fleetSize);
    return Math.round((total / n) * 100) / 100;
}

export function totalPlaysForScreens(screenCount) {
    const n = Math.max(0, Math.floor(Number(screenCount) || 0));
    return n * PLAYS_PER_SCREEN_MONTH;
}

export function normalizeScreenIds(screenIds) {
    return [...new Set(
        (screenIds || [])
            .map((id) => parseInt(id, 10))
            .filter((id) => Number.isFinite(id) && id > 0)
    )].sort((a, b) => a - b);
}

export function buildPricingTable(fleetSize) {
    const fleet = normalizeFleetSize(fleetSize);
    const tiers = [];
    for (let n = 1; n <= fleet; n += 1) {
        tiers.push({
            screenCount: n,
            totalUsd: calculateCampaignTotalUsd(n, fleet),
            effectivePerScreenUsd: calculateEffectivePerScreenUsd(n, fleet),
            totalGuaranteedPlays: totalPlaysForScreens(n),
        });
    }
    return tiers;
}
